module.exports = __webpack_public_path__ + "img/img-3.bdcce54a.jpg";